<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<ng-container *transloco="let t">
  <form [formGroup]="form">
    <div #panelOrigin>
      <ng-container *ngIf="entity || true">
        <mat-form-field #formField class="w-100 fuse-mat-dense fuse-mat-rounded mr-4" [subscriptSizing]="'dynamic'" *ngIf="rounded">
          <mat-label *ngIf="showLabel">{{ t(label) }}</mat-label>

          <input matInput formControlName="description" readonly (keydown)="openPanel($event)"/>

          <mat-icon
            matSuffix
            *ngIf="clearable && !editing && entity?.id"
            class="icon-size-5 cursor-pointer"
            [svgIcon]="'heroicons_solid:x-mark'"
            (click)="clear($event)"
          >
          </mat-icon>

          <mat-icon
            matSuffix
            class="hidden sm:flex icon-size-5 transform scale-x-110 scale-y-125 pl-2"
            [class.cursor-pointer]="!editing"
            [svgIcon]="'mat_solid:arrow_drop_down'"
            (click)="openPanel($event)"
          >
          </mat-icon>
        </mat-form-field>

        <mat-form-field #formField class="w-full" [subscriptSizing]="'dynamic'" *ngIf="!rounded">
          <mat-label *ngIf="showLabel">{{ t(label) }}</mat-label>

          <input matInput formControlName="description" readonly (keydown)="openPanel($event)"/>

          <mat-icon
            matSuffix
            *ngIf="clearable && !editing && entity?.id"
            class="icon-size-5 cursor-pointer"
            [svgIcon]="'heroicons_solid:x-mark'"
            (click)="clear($event)"
          >
          </mat-icon>

          <mat-icon
            matSuffix
            class="hidden sm:flex icon-size-5 transform scale-x-110 scale-y-125 pl-2"
            [class.cursor-pointer]="!editing"
            [svgIcon]="'mat_solid:arrow_drop_down'"
            (click)="openPanel($event)"
          >
          </mat-icon>
        </mat-form-field>
        <mat-error *ngIf="invalid">{{ t(errorMessage) }}</mat-error>
      </ng-container>

      <ng-template #panel>
        <div
          class="rounded border shadow-md bg-card"
          [style.width.px]="formFieldWidth"
        >
          <div class="flex items-center m-3 mr-2">
            <div class="flex items-center">
              <mat-icon
                class="icon-size-5"
                [svgIcon]="'heroicons_solid:magnifying-glass'"
              >
              </mat-icon>

              <div class="ml-4">
                <input
                  #newTagInput
                  class="min-w-0 py-1 border-0 w-200"
                  type="text"
                  [maxLength]="30"
                  [placeholder]="t(label)"
                  (input)="filterData($event)"
                  (keydown)="onSearchKeydown($event)"
                />
              </div>
            </div>
          </div>

          <div class="flex flex-col max-h-64 py-2 border-t overflow-y-auto">
            <ng-container *ngFor="let tag of filteredData; let i = index; trackBy: trackByFn">
              <div
                matRipple
                class="flex items-center h-10 min-h-10 pl-1 pr-4 cursor-pointer hover:bg-hover ml-4 mr-4"
                [class.bg-hover]="i === activeOptionIndex"
                [attr.data-lookup-index]="i"
                (click)="select(tag)"
                (mouseenter)="setActiveOption(i)"
                [matTooltip]="tag.tooltip ?? ''"
                matTooltipPosition="right"
              >
                <div>{{ tag.description }}</div>
              </div>
            </ng-container>

            <div *ngIf="searched && !filteredData.length" class="flex items-center h-10 min-h-10 pl-1 pr-4 ml-4 mr-4 text-secondary">
              {{ t('search.no_results_found') }}
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </form>
</ng-container>
